<template>
  <div>
    <div class="card-body contentOverflow">
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="ir"
          role="tabpanel"
          aria-labelledby="ir-tab"
        >
          <div class="row">
            <div class="col-sm-3 d-flex align-items-center text-muted">
              Scheduled
            </div>
            <div class="col-sm-6 font-weight-bold">
              <div class="row">
                <div class="col-3">
                  <small>Start:</small>
                </div>
                <div class="col-9">
                  {{ ir.start_time | moment("MM/DD/YY, hh:mmA") }}
                </div>
              </div>
              <div class="row">
                <div class="col-3">
                  <small>End:</small>
                </div>
                <div class="col-9">
                  {{ ir.end_time | moment("MM/DD/YY, hh:mmA") }}
                </div>
              </div>
            </div>
            <div class="col-sm-3 d-flex align-items-center">
              <button class="btn btn-warning btn-sm">Reschedule</button>
            </div>
          </div>
          <hr />
          <div class="form-group row">
            <label for="description" class="col-sm-3 col-form-label text-muted"
              >Description</label
            >
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                id="description"
                v-model="description"
              />
            </div>
          </div>
          <hr />
          <div class="form-group row">
            <label for="gridCoord" class="col-sm-3 col-form-label text-muted"
              >Grid Coord.</label
            >
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                id="gridCoord"
                v-model="grid_location"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3"></div>
            <div class="col-sm-9 d-flex justify-content-between">
              <a href="#">Spec. Section</a>
              <a href="#">Sheet #</a>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-3 text-muted">RFIs</div>
            <div class="col-sm-9">
              <div v-for="(rfi, index) in ir.rfis" :key="index">
                <a :href="rfi.url">{{ rfi.ir_number }}</a>
              </div>
            </div>
          </div>
          <hr />
          <div class="form-group row">
            <label for="level" class="col-sm-3 col-form-label text-muted"
              >Level</label
            >
            <div class="col-sm-9">
              <input
                type="number"
                class="form-control"
                id="level"
                v-model="building_level"
              />
              <small class="form-text text-muted">
                Level
                <i>number</i> only.
              </small>
            </div>
          </div>
          <hr />
          <div class="form-group row">
            <div class="col-sm-3 text-muted">Contact</div>
            <div class="col-sm-9">
              <p>
                {{ ir.contact.name }}
                <br />
                {{ ir.contact.company }}
                <br />
                {{ ir.contact.phone }}
              </p>
            </div>
          </div>
          <hr />
          <div class="form-group row">
            <label
              for="assignedToSelector"
              class="col-sm-3 col-form-label text-muted"
              >Assigned To</label
            >
            <div class="col-sm-9">
              <div class="input-group">
                <select
                  class="custom-select"
                  id="assignedToSelector"
                  v-model="selectedPersonnel"
                >
                  <option
                    v-for="(person, index) in this.$store.getters.personnel"
                    :key="index"
                    v-bind:value="person.id"
                    >{{
                      person.data.first_name + " " + person.data.last_name
                    }}</option
                  >
                </select>
                <div class="input-group-append">
                  <button
                    id="assignedToSelectorBtn"
                    class="btn btn-warning disabled"
                    type="button"
                  >
                    Assign
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="form-group row">
            <label for="type" class="col-sm-3 col-form-label text-muted"
              >Type</label
            >
            <div class="col-sm-9" id="type">
              <!-- NEED TO SAVE THIS WITH THE IR -->
              <select class="form-control" v-model="type.id">
                <option
                  v-for="(type, index) in this.$store.getters.irTypes"
                  :key="index"
                  v-bind:value="type.id"
                  >{{ type.data.name }}</option
                >
              </select>
            </div>
          </div>
          <hr />
          <div class="form-group row">
            <!-- NEED TO SAVE THIS WITH THE IR -->
            <label for="irFor" class="col-sm-3 col-form-label text-muted"
              >For</label
            >
            <div class="col-sm-9" id="irFor">
              <select class="form-control" v-model="irFor">
                <option
                  v-for="(irFor, index) in this.$store.getters.irFor"
                  :key="index"
                  >{{ irFor.name }}</option
                >
              </select>
            </div>
          </div>
          <hr />
          <div class="form-group row">
            <label for="qcBy" class="col-sm-3 col-form-label text-muted"
              >QC by</label
            >
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                id="qcBy"
                v-model="qc_by"
              />
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="files"
          role="tabpanel"
          aria-labelledby="files-tab"
        >
          <table class="table table-striped">
            <thead class>
              <tr>
                <th
                  scope="col"
                  class="d-flex justify-content-between align-items-center pt-0"
                >
                  Files
                  <button class="btn btn-primary">Upload File</button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a
                    v-for="(file, index) in ir.files"
                    :key="index"
                    v-bind:href="file.url"
                    target="_blank"
                    >{{ file.name }}</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="tab-pane fade"
          id="history"
          role="tabpanel"
          aria-labelledby="history-tab"
        >
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Date/Time</th>
                <th scope="col">User</th>
                <th scope="col">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>09/19/2019 3:12 PM</td>
                <td>Diego Franco</td>
                <td>Assigned to Bob Johnson</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="tab-pane fade"
          id="complete"
          role="tabpanel"
          aria-labelledby="complete-tab"
        >
          <div class="form-group row">
            <label for="notes" class="col-sm-3 col-form-label text-muted"
              >Notes</label
            >
            <div class="col-sm-9" id="notes">
              <textarea class="form-control"></textarea>
            </div>
          </div>
          <hr />
          <div class="form-group row">
            <label for="status" class="col-sm-3 col-form-label text-muted"
              >Status</label
            >
            <div class="col-sm-9">
              <select class="form-control">
                <option></option>
                <option>Pass</option>
                <option>Fail</option>
                <option>Not Ready</option>
              </select>
            </div>
          </div>
          <hr />
          <button class="btn btn-primary">Complete & Submit IR</button>
        </div>
      </div>
    </div>
    <div class="bottomMenu">
      <a href="#" class="ml-3 mr-2" title="Open printable IR">Print</a>
      <small>|</small>
      <a href="#" class="mx-2" title="Open IR in new window">Open</a>

      <button
        class="btn btn-success btn-sm ml-auto mr-2"
        disabled
        v-if="this.$store.getters.irSaved"
      >
        Changes Saved
      </button>
      <button
        class="btn btn-success btn-sm ml-auto mr-2"
        v-if="!this.$store.getters.irSaved"
        v-on:click="$store.dispatch('saveIR')"
      >
        Save Changes
      </button>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "IRDetails",
  computed: {
    ...mapFields([
      "ir.description",
      "ir.grid_location",
      "ir.building_level",
      "ir.qc_by",
      "ir.type"
    ]),
    ir: function() {
      return this.$store.getters.ir;
    },
    selectedPersonnel: function() {
      return this.ir.assigned_to.id;
    },

    irFor: function() {
      return this.ir.for.name;
    }
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "updateField") {
        this.$store.commit("irSaved", false);
      }
    });
  },
  mounted() {
    this.$store.dispatch("loadPersonnel");
    this.$store.dispatch("loadIRTypes");
  }
};
</script>

<style scoped>
.table thead th {
  border-top: 0px solid #fff;
}

.bottomMenu {
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  height: 44px;
  display: flex;
  align-items: center;
}

.contentOverflow {
  max-height: calc(100vh - 297px);
  overflow: auto;
}
</style>
